module.exports = __webpack_public_path__ + "static/media/PondsBylaws_2nd_Amend.e9a508a1.pdf";